export default __webpack_public_path__ + "static/media/Vector 76 (3).43aad409.svg";